import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Token_NULL_getInstance1u01li7150917 as Token_NULL_getInstance } from './json/JsonReader.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Present1shu3953j96zb as Present,
  Absent_getInstance17o8jlyfouexf as Absent_getInstance,
  Optional8wzzg0qzssox as Optional,
} from './Optional.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Companion_instance6tw5jj3chxse as Companion_instance } from './json/MapJsonReader.mjs';
import { ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException } from '../exception/Exceptions.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from './json/MapJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from './json/JsonWriters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { readAny17j2jqaxubdko as readAny } from './json/JsonReaders.mjs';
import { Upload1b180qcf3cx10 as Upload } from './Upload.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_StringAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return StringAdapter;
}
var StringAdapter;
function get_IntAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return IntAdapter;
}
var IntAdapter;
function get_DoubleAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return DoubleAdapter;
}
var DoubleAdapter;
function get_FloatAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return FloatAdapter;
}
var FloatAdapter;
function get_LongAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return LongAdapter;
}
var LongAdapter;
function get_BooleanAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return BooleanAdapter;
}
var BooleanAdapter;
function get_AnyAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return AnyAdapter;
}
var AnyAdapter;
function get_UploadAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return UploadAdapter;
}
var UploadAdapter;
function get_NullableStringAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return NullableStringAdapter;
}
var NullableStringAdapter;
var NullableDoubleAdapter;
function get_NullableIntAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return NullableIntAdapter;
}
var NullableIntAdapter;
function get_NullableBooleanAdapter() {
  _init_properties_Adapters_kt__aoa3ac();
  return NullableBooleanAdapter;
}
var NullableBooleanAdapter;
var NullableAnyAdapter;
var NullableLongAdapter;
var ApolloOptionalStringAdapter;
var ApolloOptionalDoubleAdapter;
var ApolloOptionalIntAdapter;
var ApolloOptionalBooleanAdapter;
var ApolloOptionalAnyAdapter;
var NullableAdapterClass;
function NullableAdapter() {
  if (NullableAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.v3x_1 = wrappedAdapter;
        var tmp = this.v3x_1;
        // Inline function 'kotlin.check' call
        if (!!(tmp instanceof NullableAdapter())) {
          var message = 'The adapter is already nullable';
          throw IllegalStateException().o(toString(message));
        }
      }
      t3x(reader, customScalarAdapters) {
        var tmp;
        if (reader.x3x().equals(Token_NULL_getInstance())) {
          reader.w3x();
          tmp = null;
        } else {
          tmp = this.v3x_1.t3x(reader, customScalarAdapters);
        }
        return tmp;
      }
      y3x(writer, customScalarAdapters, value) {
        if (value == null) {
          writer.z3x();
        } else {
          this.v3x_1.u3x(writer, customScalarAdapters, value);
        }
      }
      u3x(writer, customScalarAdapters, value) {
        return this.y3x(writer, customScalarAdapters, value);
      }
    }
    initMetadataForClass($, 'NullableAdapter', VOID, VOID, [Adapter()]);
    NullableAdapterClass = $;
  }
  return NullableAdapterClass;
}
function nullable(_this__u8e3s4) {
  _init_properties_Adapters_kt__aoa3ac();
  return new (NullableAdapter())(_this__u8e3s4);
}
var ApolloOptionalAdapterClass;
function ApolloOptionalAdapter() {
  if (ApolloOptionalAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.a3y_1 = wrappedAdapter;
      }
      t3x(reader, customScalarAdapters) {
        var tmp;
        if (reader.x3x().equals(Token_NULL_getInstance())) {
          reader.w3x();
          tmp = Absent_getInstance();
        } else {
          tmp = new (Present())(this.a3y_1.t3x(reader, customScalarAdapters));
        }
        return tmp;
      }
      b3y(writer, customScalarAdapters, value) {
        if (value instanceof Present()) {
          this.a3y_1.u3x(writer, customScalarAdapters, value.c3y_1);
        } else {
          writer.z3x();
        }
      }
      u3x(writer, customScalarAdapters, value) {
        return this.b3y(writer, customScalarAdapters, value instanceof Optional() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ApolloOptionalAdapter', VOID, VOID, [Adapter()]);
    ApolloOptionalAdapterClass = $;
  }
  return ApolloOptionalAdapterClass;
}
var ObjectAdapterClass;
function ObjectAdapter() {
  if (ObjectAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter, buffered) {
        this.d3y_1 = wrappedAdapter;
        this.e3y_1 = buffered;
      }
      t3x(reader, customScalarAdapters) {
        var tmp;
        if (this.e3y_1) {
          tmp = Companion_instance.f3y(reader);
        } else {
          tmp = reader;
        }
        var actualReader = tmp;
        actualReader.g3y();
        try {
          var result = this.d3y_1.t3x(actualReader, customScalarAdapters);
          actualReader.h3y();
          return result;
        } catch ($p) {
          if ($p instanceof ApolloGraphQLException()) {
            var e = $p;
            while (actualReader.q1()) {
              actualReader.i3y();
              actualReader.w3x();
            }
            actualReader.h3y();
            throw e;
          } else {
            throw $p;
          }
        }
      }
      u3x(writer, customScalarAdapters, value) {
        var tmp;
        if (this.e3y_1) {
          tmp = !(writer instanceof MapJsonWriter());
        } else {
          tmp = false;
        }
        if (tmp) {
          var mapWriter = new (MapJsonWriter())();
          mapWriter.g3y();
          this.d3y_1.u3x(mapWriter, customScalarAdapters, value);
          mapWriter.h3y();
          writeAny(writer, ensureNotNull(mapWriter.m3y()));
        } else {
          writer.g3y();
          this.d3y_1.u3x(writer, customScalarAdapters, value);
          writer.h3y();
        }
      }
    }
    initMetadataForClass($, 'ObjectAdapter', VOID, VOID, [Adapter()]);
    ObjectAdapterClass = $;
  }
  return ObjectAdapterClass;
}
function obj(_this__u8e3s4, buffered) {
  buffered = buffered === VOID ? false : buffered;
  _init_properties_Adapters_kt__aoa3ac();
  return new (ObjectAdapter())(_this__u8e3s4, buffered);
}
var ListAdapterClass;
function ListAdapter() {
  if (ListAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.n3y_1 = wrappedAdapter;
      }
      t3x(reader, customScalarAdapters) {
        reader.o3y();
        // Inline function 'kotlin.collections.mutableListOf' call
        var list = ArrayList().p2();
        try {
          while (reader.q1()) {
            list.j2(this.n3y_1.t3x(reader, customScalarAdapters));
          }
          reader.p3y();
          return list;
        } catch ($p) {
          if ($p instanceof ApolloGraphQLException()) {
            var e = $p;
            while (reader.q1()) {
              reader.w3x();
            }
            reader.p3y();
            throw e;
          } else {
            throw $p;
          }
        }
      }
      q3y(writer, customScalarAdapters, value) {
        writer.o3y();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = value.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          this.n3y_1.u3x(writer, customScalarAdapters, element);
        }
        writer.p3y();
      }
      u3x(writer, customScalarAdapters, value) {
        return this.q3y(writer, customScalarAdapters, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ListAdapter', VOID, VOID, [Adapter()]);
    ListAdapterClass = $;
  }
  return ListAdapterClass;
}
function list(_this__u8e3s4) {
  _init_properties_Adapters_kt__aoa3ac();
  return new (ListAdapter())(_this__u8e3s4);
}
var PresentAdapterClass;
function PresentAdapter() {
  if (PresentAdapterClass === VOID) {
    class $ {
      constructor(wrappedAdapter) {
        this.r3y_1 = wrappedAdapter;
      }
      t3x(reader, customScalarAdapters) {
        return new (Present())(this.r3y_1.t3x(reader, customScalarAdapters));
      }
      s3y(writer, customScalarAdapters, value) {
        this.r3y_1.u3x(writer, customScalarAdapters, value.c3y_1);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.s3y(writer, customScalarAdapters, value instanceof Present() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'PresentAdapter', VOID, VOID, [Adapter()]);
    PresentAdapterClass = $;
  }
  return PresentAdapterClass;
}
function present(_this__u8e3s4) {
  _init_properties_Adapters_kt__aoa3ac();
  return new (PresentAdapter())(_this__u8e3s4);
}
var StringAdapter$1Class;
function StringAdapter$1() {
  if (StringAdapter$1Class === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        return ensureNotNull(reader.t3y());
      }
      u3y(writer, customScalarAdapters, value) {
        writer.v3y(value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.u3y(writer, customScalarAdapters, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    StringAdapter$1Class = $;
  }
  return StringAdapter$1Class;
}
var IntAdapter$1Class;
function IntAdapter$1() {
  if (IntAdapter$1Class === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        return reader.pk();
      }
      w3y(writer, customScalarAdapters, value) {
        writer.x3y(value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.w3y(writer, customScalarAdapters, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    IntAdapter$1Class = $;
  }
  return IntAdapter$1Class;
}
var DoubleAdapter$1Class;
function DoubleAdapter$1() {
  if (DoubleAdapter$1Class === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        return reader.y3y();
      }
      z3y(writer, customScalarAdapters, value) {
        writer.a3z(value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.z3y(writer, customScalarAdapters, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    DoubleAdapter$1Class = $;
  }
  return DoubleAdapter$1Class;
}
var FloatAdapter$1Class;
function FloatAdapter$1() {
  if (FloatAdapter$1Class === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        return reader.y3y();
      }
      b3z(writer, customScalarAdapters, value) {
        writer.a3z(value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.b3z(writer, customScalarAdapters, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    FloatAdapter$1Class = $;
  }
  return FloatAdapter$1Class;
}
var LongAdapter$1Class;
function LongAdapter$1() {
  if (LongAdapter$1Class === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        return reader.go();
      }
      c3z(writer, customScalarAdapters, value) {
        writer.d3z(value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.c3z(writer, customScalarAdapters, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    LongAdapter$1Class = $;
  }
  return LongAdapter$1Class;
}
var BooleanAdapter$1Class;
function BooleanAdapter$1() {
  if (BooleanAdapter$1Class === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        return reader.jo();
      }
      e3z(writer, customScalarAdapters, value) {
        writer.f3z(value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.e3z(writer, customScalarAdapters, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    BooleanAdapter$1Class = $;
  }
  return BooleanAdapter$1Class;
}
var AnyAdapter$1Class;
function AnyAdapter$1() {
  if (AnyAdapter$1Class === VOID) {
    class $ {
      g3z(reader) {
        return ensureNotNull(readAny(reader));
      }
      h3z(writer, value) {
        writeAny(writer, value);
      }
      t3x(reader, customScalarAdapters) {
        return this.g3z(reader);
      }
      i3z(writer, customScalarAdapters, value) {
        this.h3z(writer, value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.i3z(writer, customScalarAdapters, !(value == null) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    AnyAdapter$1Class = $;
  }
  return AnyAdapter$1Class;
}
var UploadAdapter$1Class;
function UploadAdapter$1() {
  if (UploadAdapter$1Class === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        // Inline function 'kotlin.error' call
        var message = 'File Upload used in output position';
        throw IllegalStateException().o(toString(message));
      }
      j3z(writer, customScalarAdapters, value) {
        writer.k3z(value);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.j3z(writer, customScalarAdapters, (!(value == null) ? isInterface(value, Upload()) : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Adapter()]);
    UploadAdapter$1Class = $;
  }
  return UploadAdapter$1Class;
}
var properties_initialized_Adapters_kt_fd10e2;
function _init_properties_Adapters_kt__aoa3ac() {
  if (!properties_initialized_Adapters_kt_fd10e2) {
    properties_initialized_Adapters_kt_fd10e2 = true;
    StringAdapter = new (StringAdapter$1())();
    IntAdapter = new (IntAdapter$1())();
    DoubleAdapter = new (DoubleAdapter$1())();
    FloatAdapter = new (FloatAdapter$1())();
    LongAdapter = new (LongAdapter$1())();
    BooleanAdapter = new (BooleanAdapter$1())();
    AnyAdapter = new (AnyAdapter$1())();
    UploadAdapter = new (UploadAdapter$1())();
    NullableStringAdapter = nullable(get_StringAdapter());
    NullableDoubleAdapter = nullable(get_DoubleAdapter());
    NullableIntAdapter = nullable(get_IntAdapter());
    NullableBooleanAdapter = nullable(get_BooleanAdapter());
    NullableAnyAdapter = nullable(get_AnyAdapter());
    NullableLongAdapter = nullable(get_LongAdapter());
    ApolloOptionalStringAdapter = new (ApolloOptionalAdapter())(get_StringAdapter());
    ApolloOptionalDoubleAdapter = new (ApolloOptionalAdapter())(get_DoubleAdapter());
    ApolloOptionalIntAdapter = new (ApolloOptionalAdapter())(get_IntAdapter());
    ApolloOptionalBooleanAdapter = new (ApolloOptionalAdapter())(get_BooleanAdapter());
    ApolloOptionalAnyAdapter = new (ApolloOptionalAdapter())(get_AnyAdapter());
  }
}
//region block: exports
export {
  get_AnyAdapter as get_AnyAdapterx2g0krnqn0y9,
  get_BooleanAdapter as get_BooleanAdapterefxw889yjdy4,
  get_DoubleAdapter as get_DoubleAdapter3vjvxl0ttbawu,
  get_FloatAdapter as get_FloatAdapter8hkphxq3v57l,
  get_IntAdapter as get_IntAdapter2kzerdn7hhunh,
  get_LongAdapter as get_LongAdapter1acs38m0a7icu,
  get_NullableBooleanAdapter as get_NullableBooleanAdapter3vvq2rksy333a,
  get_NullableIntAdapter as get_NullableIntAdapter1poaa869odci7,
  get_NullableStringAdapter as get_NullableStringAdapter3fffxc67fmluc,
  get_StringAdapter as get_StringAdapter1plpsgiy8rwhj,
  get_UploadAdapter as get_UploadAdapter1jp2f4wtvjtde,
  list as list2lpjhmv1d2k19,
  nullable as nullable1in0t8o94jx9t,
  obj as obj2vqjd1bjrpmyg,
  present as presentmhd0a0ip21um,
};
//endregion

//# sourceMappingURL=Adapters.mjs.map
